import { LexicalComposer } from '@lexical/react/LexicalComposer'
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin'
import { ContentEditable } from '@lexical/react/LexicalContentEditable'
import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin'
import { AutoFocusPlugin } from '@lexical/react/LexicalAutoFocusPlugin'
import { LinkPlugin } from '@lexical/react/LexicalLinkPlugin'
import { ListPlugin } from '@lexical/react/LexicalListPlugin'
import { MarkdownShortcutPlugin } from '@lexical/react/LexicalMarkdownShortcutPlugin'
import { HorizontalRulePlugin } from '@lexical/react/LexicalHorizontalRulePlugin'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import React, { useEffect } from 'react'
import { View } from 'styles/reactnative'
import { $generateHtmlFromNodes } from '@lexical/html'
import { editorConfig } from './editorConfig'
import ToolbarPlugin from './ToolbarPlugin'
import './styles.css'
import { TablePlugin } from '@lexical/react/LexicalTablePlugin'
import { TableCellNode, TableNode, TableRowNode } from '@lexical/table'

function OnChangePlugin({ onChange }) {
	const [editor] = useLexicalComposerContext()
	useEffect(() => {
		return editor.registerUpdateListener(({ editorState }) => {
			editorState.read(() => {
				const html = $generateHtmlFromNodes(editor)
				onChange(html)
			})
		})
	}, [editor, onChange])
	return null
}

function LexicalErrorBoundary({ children }) {
	return <React.Fragment>{children}</React.Fragment>
}

const RichTextCreateEditor = ({
	content,
	setContent,
	boxheight = 400,
	boxwidth = '100%',
}) => {
	const initialConfig = {
		...editorConfig,
		nodes: [...editorConfig.nodes, TableCellNode, TableNode, TableRowNode],
		onError: (error) => console.error(error),
	}

	return (
		<View style={{ height: boxheight, width: '100%' }}>
			<LexicalComposer initialConfig={initialConfig}>
				<div className="editor-container" style={{ height: boxheight, width: boxwidth, background: '#f9f9f9' }}>
					<ToolbarPlugin />
					<RichTextPlugin
						contentEditable={<ContentEditable className="editor-input" />}
						placeholder={<div className="editor-placeholder">내용을 입력하세요...</div>}
						ErrorBoundary={LexicalErrorBoundary}
					
					/>
					<HistoryPlugin />
					<AutoFocusPlugin />
					<LinkPlugin />
					<ListPlugin />
					<HorizontalRulePlugin />
					<MarkdownShortcutPlugin />
					<TablePlugin />
					<OnChangePlugin onChange={setContent} />
				</div>
			</LexicalComposer>
		</View>
	)
}

export default RichTextCreateEditor

// import { EditorState, convertToRaw } from 'draft-js'
// import { Editor } from 'react-draft-wysiwyg'
// import draftToMarkdown from 'draftjs-to-markdown'

// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
// import React, { useState } from 'react'
// import { View } from 'styles/reactnative'

// const RichTextEditor = ({ content, setContent }) => {
// 	const [editorState, setEditorState] = useState(EditorState.createEmpty())

// 	const handleEditorChange = state => {
// 		const rawContentState = convertToRaw(editorState.getCurrentContent())
// 		const markdown = draftToMarkdown(rawContentState)
// 		setContent(markdown)
// 		setEditorState(state)
// 	}
// 	console.log(content)
// 	return (
// 		<View style={{ height: 300 }}>
// 			<Editor
// 				editorState={editorState}
// 				editorStyle={{
// 					height: 200,
// 					background: '#f9f9f9',
// 				}}
// 				toolbarStyle={{
// 					background: '#f9f9f9',
// 				}}
// 				onEditorStateChange={handleEditorChange}
// 			/>
// 		</View>
// 	)
// }

// export default RichTextEditor
